module.exports = __webpack_public_path__ + "static/img/range4.f5dea30d.png";